<div class="container" >
  <div [ngClass]="{label: true, 'label-selected': _selected}" (click)="select(false)">{{options[0]}}</div>
  <div class="slider-track" [ngClass]="{selectedTrack: _selected}" (click)="toggle()">
    <div [ngClass]="{'handle': true, selected: _selected}"></div>
  </div>
  <div [ngClass]="{label: true, 'label-selected': !_selected}" (click)="select(true)">{{options[1]}}</div>
</div>
